export default __webpack_public_path__ + "static/media/Return-Policy.b497a61e.jpg";